/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendVentureFundDividendDto } from '../models/backend-venture-fund-dividend-dto';
import { ventureFundsVentureFundDividendsCopyCreate } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-copy-create';
import { VentureFundsVentureFundDividendsCopyCreate$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-copy-create';
import { ventureFundsVentureFundDividendsCreate } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-create';
import { ventureFundsVentureFundDividendsCreate$FormData } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-create-form-data';
import { VentureFundsVentureFundDividendsCreate$FormData$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-create-form-data';
import { VentureFundsVentureFundDividendsCreate$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-create';
import { ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-create-x-www-form-urlencoded';
import { VentureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-create-x-www-form-urlencoded';
import { ventureFundsVentureFundDividendsDestroy } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-destroy';
import { VentureFundsVentureFundDividendsDestroy$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-destroy';
import { ventureFundsVentureFundDividendsPartialUpdate } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-partial-update';
import { ventureFundsVentureFundDividendsPartialUpdate$FormData } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-partial-update-form-data';
import { VentureFundsVentureFundDividendsPartialUpdate$FormData$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-partial-update-form-data';
import { VentureFundsVentureFundDividendsPartialUpdate$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-partial-update';
import { ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-partial-update-x-www-form-urlencoded';
import { VentureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-partial-update-x-www-form-urlencoded';
import { ventureFundsVentureFundDividendsUpdate } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-update';
import { ventureFundsVentureFundDividendsUpdate$FormData } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-update-form-data';
import { VentureFundsVentureFundDividendsUpdate$FormData$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-update-form-data';
import { VentureFundsVentureFundDividendsUpdate$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-update';
import { ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-update-x-www-form-urlencoded';
import { VentureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund-dividends/venture-funds-venture-fund-dividends-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiVentureFundDividendsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ventureFundsVentureFundDividendsCreate()` */
  static readonly VentureFundsVentureFundDividendsCreatePath = '/api/venture_funds/venture-fund-dividends/';

  /**
   * Создать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundDividendsCreate$Response(
    params: VentureFundsVentureFundDividendsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundDividendsCreate(
    params: VentureFundsVentureFundDividendsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /**
   * Создать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /**
   * Создать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundDividendsCreate$FormData$Response(
    params: VentureFundsVentureFundDividendsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundDividendsCreate$FormData(
    params: VentureFundsVentureFundDividendsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundDividendsUpdate()` */
  static readonly VentureFundsVentureFundDividendsUpdatePath = '/api/venture_funds/venture-fund-dividends/{id}/';

  /**
   * Обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundDividendsUpdate$Response(
    params: VentureFundsVentureFundDividendsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundDividendsUpdate(
    params: VentureFundsVentureFundDividendsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /**
   * Обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /**
   * Обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundDividendsUpdate$FormData$Response(
    params: VentureFundsVentureFundDividendsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundDividendsUpdate$FormData(
    params: VentureFundsVentureFundDividendsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundDividendsDestroy()` */
  static readonly VentureFundsVentureFundDividendsDestroyPath = '/api/venture_funds/venture-fund-dividends/{id}/';

  /**
   * Удалить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundDividendsDestroy$Response(
    params: VentureFundsVentureFundDividendsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsVentureFundDividendsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundDividendsDestroy(
    params: VentureFundsVentureFundDividendsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsVentureFundDividendsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundDividendsPartialUpdate()` */
  static readonly VentureFundsVentureFundDividendsPartialUpdatePath = '/api/venture_funds/venture-fund-dividends/{id}/';

  /**
   * Частично обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundDividendsPartialUpdate$Response(
    params: VentureFundsVentureFundDividendsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundDividendsPartialUpdate(
    params: VentureFundsVentureFundDividendsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /**
   * Частично обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /**
   * Частично обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundDividendsPartialUpdate$FormData$Response(
    params: VentureFundsVentureFundDividendsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить дивиденд венчурного фонда.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundDividendsPartialUpdate$FormData(
    params: VentureFundsVentureFundDividendsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundDividendsCopyCreate()` */
  static readonly VentureFundsVentureFundDividendsCopyCreatePath =
    '/api/venture_funds/venture-fund-dividends/{id}/copy/';

  /**
   * Скопировать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundDividendsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundDividendsCopyCreate$Response(
    params: VentureFundsVentureFundDividendsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
    return ventureFundsVentureFundDividendsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать дивиденд венчурного фонда.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundDividendsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundDividendsCopyCreate(
    params: VentureFundsVentureFundDividendsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDividendDto> {
    return this.ventureFundsVentureFundDividendsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDividendDto>): BackendVentureFundDividendDto => r.body),
    );
  }
}
